import React, { useState } from "react";
import { Box, Button, Grid2, Stack, Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TableComponent from "components/grid";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { useParams } from "react-router-dom";
import { useGetAllRiskQuery } from "store/slices/apis/riskPackageSlice";
import moment from "moment";
import ApproveRiskComponent from "components/action/ApproveRiskComponent";
import RejectRiskComponent from "components/action/RejectRiskComponent";
import EditClearance from "./EditClearance";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { IoMdSearch } from "react-icons/io";
import RejectClearanceComponent from "components/action/RejectClearanceComponent";
import ApproveClearanceComponent from "components/action/ApproveClearanceComponent";
import { useGetAllClearanceQuery } from "store/slices/apis/clearancePackageSlice";
import { ReactComponent as SearchIcon } from "assets/PwC_Funct_Icons_Search_Outline_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

const columns = [
  {
    name: "Clearance ID",
    field: "clearance_number",
    renderer(params) {
      return (
        <Stack direction="row" spacing={1}>
          {params?.clearance_number && (
            <Chip
              label={params?.clearance_number}
              size="small"
              sx={{
                fontSize: "12px",
                "& .MuiChip-label": {
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  fontWeight: 600,
                },
              }}
            />
          )}
        </Stack>
      );
    },
  },
  // {
  //   name: "S No",
  //   field: "s_no",
  // },
  {
    name: "Workflow Status",
    field: "approved_status",
    renderer(params) {
      return (
        <>
          {params?.approved_status === "Pending_for_Approval"
            ? "Pending for approval"
            : params?.approved_status}
        </>
      );
    },
  },
  {
    name: "Status",
    field: "status",
  },
  {
    name: "Created Date",
    field: "createddate",
    renderer(params) {
      return (
        <>
          {params?.createddate
            ? moment(params.createddate).format("DD/MM/YY")
            : "N.A."}
        </>
      );
    },
  },
  {
    name: "Project",
    field: "project",
  },
  {
    name: "Approval Compliance Description",
    field: "approval_compliance_description",
  },
  {
    name: "Compliance Owner",
    field: "compliance_owner",
  },
  {
    name: "Content Owner",
    field: "content_owner",
  },
  {
    name: "Approving Authority Agency",
    field: "approving_authority_agency",
  },
  {
    name: "Plan Date",
    field: "plan_date",
    renderer(params) {
      return (
        <>
          {params?.plan_date
            ? moment(params.plan_date).format("DD/MM/YY")
            : "N.A."}
        </>
      );
    },
  },
  {
    name: "Actual Expected Date",
    field: "actual_expected_date",
    renderer(params) {
      return (
        <>
          {params?.actual_expected_date
            ? moment(params.actual_expected_date).format("DD/MM/YY")
            : "N.A."}
        </>
      );
    },
  },
  {
    name: "Revised Plan Date",
    field: "revised_plan_date",
    renderer(params) {
      return (
        <>
          {params?.revised_plan_date
            ? moment(params.revised_plan_date).format("DD/MM/YY")
            : "N.A."}
        </>
      );
    },
  },
  {
    name: "Escalation Required",
    field: "escalation_required",
    renderer(params) {
      return <>{params?.escalation_required === true ? "Yes" : "No"}</>;
    },
  },
  // {
  //   name: "Current Status",
  //   field: "current_status",
  // },
  {
    name: "Action",
    field: "action",
    option: {
      view: true,
      delete: false,
      edit: false,
      acceptReject: true,
    },
  },
];

const ClearancePendingApproval = () => {
  const theme = useTheme();
  const [pageNumber, setPageNumber] = useState(1);
  const [isIssueReject, setIsIssueReject] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [isIssueApprove, setIsIssueApprove] = useState(false);
  const { projectId } = useParams();
  const [approvedStatus, setApprovedStatus] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [filters, setFilters] = useState({
    approvedStatus: "",
    fromDate: "",
    toDate: "",
  });
  const {
    data: allClearance,
    refetch,
    isLoading,
  } = useGetAllClearanceQuery({
    ProjectId: projectId,
    sortBy: "createddate",
    sortOrder: "desc",
    approved_status: "Pending_for_Approval",
    from: filters?.fromDate,
    to: filters?.toDate,
    page: pageNumber,
    pageSize: 10,
  });
  const [issueData, setEditIssueData] = useState(null);
  const [isViewIssueModal, setIsViewIssueModal] = useState(false);

  const handleActionAcceptIssue = (row) => {

    setIsIssueApprove((prev) => {
      const newState = !prev;
      setRowData(newState ? row : null);
      return newState;
    });
  };

  const handleActionView = (row) => {

    setIsViewIssueModal(!isViewIssueModal);
    if (!issueData) {
      setEditIssueData(row);
    } else {
      setEditIssueData(null);
    }
  };

  const handleActionRejectIssue = (row) => {
    setIsIssueReject((prev) => {
      const newState = !prev;
      setRowData(newState ? row : null);
      return newState;
    });
  };

  const CustomCalendarIcon = (props) => (
    <CalendarIcon {...props} style={{ width: 26, height: 26, fill: "#696969 ", stroke: "#696969", strokeWidth: 4 }} />
  );

  return (
    <>
      <Grid2 container spacing={2} sx={{ mt: "20px" }}>
        <Grid2 size={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Stack
              direction="row"
              spacing={2}
              sx={{
                flexGrow: 2,
                alignItems: "center",
                "& .MuiStack-root": {
                  paddingTop: "15px",
                },
              }}
            >
              {/* <Autocomplete
                                                 options={approvedStatuses}
                                                 getOptionLabel={(option) => option?.label}
                                                 onChange={(_, newValue) =>
                                                   setApprovedStatus(newValue ? newValue?.value : "")
                                                 }
                                                 renderInput={(params) => (
                                                   <TextField
                                                     {...params}
                                                     label="Current Status"
                                                     name="approvedStatus"
                                                     // slotProps={{ inputLabel: { shrink: true } }}
                                                     variant="outlined"
                                                     size="small"
                                                     sx={{
                                                       "& .MuiFilledInput-root": {
                                                         backgroundColor: "#fff",
                                                       },
                                 
                                                       "& .MuiInputLabel-root": {
                                                         top: "-3px",
                                                       },                    
                                                       minWidth: "230px",
                                                     }}
                                                   />
                                                 )}
                                                 ListboxProps={{
                                                   sx: { fontSize: "13px" },
                                                 }}
                                                 // sx={{ width: "23%", marginTop: "7px !important" }}
                                               /> */}
              <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    label="From Date"
                    value={fromDate}
                    format="DD-MM-YYYY"
                    onChange={(newValue) => setFromDate(newValue)}
                    slots={{
                      openPickerIcon: CustomCalendarIcon,
                    }}
                    slotProps={{
                      textField: {
                        sx: {
                          minWidth: 150,
                          "& .MuiOutlinedInput-input": {
                            padding: "10px",
                          },

                          "& .MuiInputLabel-root": {
                            top: "-6px",
                          },
                        },
                      },
                      field: {
                        clearable: true,
                        onClear: () =>
                          setFilters({
                            fromDate: "",
                            toDate: toDate
                              ? dayjs(toDate).format("YYYY-MM-DD")
                              : "",
                            approvedStatus,
                          }),
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    label="To Date"
                    value={toDate}
                    format="DD-MM-YYYY"
                    clearable={true}
                    onChange={(newValue) => setToDate(newValue)}
                    slots={{
                      openPickerIcon: CustomCalendarIcon,
                    }}
                    slotProps={{
                      textField: {
                        sx: {
                          minWidth: 150,
                          "& .MuiOutlinedInput-input": {
                            padding: "10px",
                          },

                          "& .MuiInputLabel-root": {
                            top: "-6px",
                          },
                        },
                      },
                      field: {
                        clearable: true,
                        onClear: () =>
                          setFilters({
                            fromDate: fromDate
                              ? dayjs(fromDate).format("YYYY-MM-DD")
                              : "",
                            toDate: "",
                            approvedStatus,
                          }),
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <Button
                loading={isLoading}
                onClick={() => {
                  setFilters({
                    fromDate: fromDate
                      ? dayjs(fromDate).format("YYYY-MM-DD")
                      : "",
                    toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : "",
                    approvedStatus,
                  });
                }}
                size="large"
                //  startIcon={<IoMdSearch />}
                startIcon={<SearchIcon style={{ height: "20px", width: "20px", fill: "#808080" }} />}
                variant="outlined"
                sx={{
                  color: `${theme?.customSettings?.themeColor}`,
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  background: "none",
                  textTransform: "inherit",
                  padding: "6px 20px",
                  marginTop: "12px !important",
                }}
              >
                Search
              </Button>
            </Stack>
          </Box>
        </Grid2>
        <Grid2 size={12} sx={{ mt: 2 }}>
          <TableComponent
            columns={columns}
            data={allClearance?.data?.filter((risk) => risk?.active === true)}
            // actionDelete={handleActionDelete}
            // actionEdit={handleActionEdit}
            actionView={handleActionView}
            actionAccept={handleActionAcceptIssue}
            actionReject={handleActionRejectIssue}
            isLoading={isLoading}
          />
          {!isLoading && (
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              <PaginationComponent
                pageNumber={allClearance?.pagination?.currentPage || 1}
                totalPages={allClearance?.pagination?.totalPages || 1}
                onPageChange={setPageNumber}
              />
            </Box>
          )}
        </Grid2>
      </Grid2>
      {isViewIssueModal && (
        <EditClearance
          cancelIssue={handleActionView}
          open={isViewIssueModal}
          data={issueData}
          isViewIssueModal
        />
      )}
      <ApproveClearanceComponent
        open={isIssueApprove}
        cancel={handleActionAcceptIssue}
        rowData={rowData}
        keys={"clearance"}
        refetch={refetch}
      />
      <RejectClearanceComponent
        open={isIssueReject}
        cancel={handleActionRejectIssue}
        rowData={rowData}
        keys={"clearance"}
        refetch={refetch}
      />
    </>
  );
};

export default ClearancePendingApproval;
